import Plans from "./pages/plansList";
import PlansForm from "./pages/plansForm";

export const PlansRoutes = [
    {
        path: "/planos",
        component: Plans,
    },
    {
        path: "/planos/novo",
        component: PlansForm,
    },
    {
        path: "/planos/edit/:id",
        component: PlansForm,
    },
];
